

// @ts-nocheck

/*



*/

import vSelect from 'vue-select'
import Vue from "vue";
import Googlereview from "../../../platformlogos/Googlereview.vue";
import Facebook from "../../../platformlogos/Facebook.vue";
import Tripadvisor from "../../../platformlogos/Tripadvisor.vue";
import Capterra from "../../../platformlogos/Capterra.vue";
import Foursquare from "../../../platformlogos/Foursquare.vue";
import G2 from "../../../platformlogos/G2.vue";
import Trustpilot from "../../../platformlogos/Trustpilot.vue";
import Yelp from "../../../platformlogos/Yelp.vue";
import Draggable from "vuedraggable";

import { encode } from "../../../../../../../Overarching Resources/TS/Survey/surveyHelperMethods";

import getCustomActions from "../../../../methods/getCustomActions"

const actionsMappedToLanguageSlugs = {
  fbr: "reviewOnFacebook",
  gp: "reviewOnGoogle",
  tp: "reviewOnTrustpilot",
  g2: "reviewOnG2",
  ca: "reviewOnCapterra",
  ta: "reviewOnTripadvisor",
  ye: "reviewOnYelp",
  fs: "reviewOnFoursquare",
};

export default Vue.extend({
  data() {
    return {
      customActions: getCustomActions().map((el,i) => ({...el, i})),
      validPlatforms: [],
      editCurrentCustomAction: false,
      editingExistingAction: false, // OR THE INDEX OF THE ITEM IN VALIDPLATFORMS
      selectedCustomActionI: 1,
      currentCustomAction: {
          actionText: '', 
          actionURL: '',  
          actionImageType: 'img',
          actionImageData: ''
        }
    }
  },
  props: {
    fieldAddress: Array,
  },
  created(): void {
    this.refreshOptions();
  },
  methods: {
    cancelEditAddAction(): void {
      // @ts-ignore
      this.editCurrentCustomAction = false  
      this.editingExistingAction = false
      this.currentCustomAction = {
          actionText: '', 
          actionURL: '',  
          actionImageType: 'img',
          actionImageData: ''
        }
    },
    confirmAddAction(): void {      
      const currentCustomActionImg = this.customActions[this.selectedCustomActionI]      
      // @ts-ignore      
      const item = {
        platformCode: 'custom',        
        text: this.currentCustomAction.actionText,
        active: true,
        actionURL: this.currentCustomAction.actionURL,
        actionImageType: currentCustomActionImg.url? 'img' : 'svg',
        actionImageData: currentCustomActionImg.url ? currentCustomActionImg.url : currentCustomActionImg.svgCode,
      }
      if (this.editingExistingAction !== false) {
        //update validPlatforms reactively:
        this.validPlatforms.splice(this.editingExistingAction, 1, item)        
      } else {
        this.validPlatforms.push(item)
      }            
      this.cancelEditAddAction()
      //this.refreshOptions();

    },
    editCustomAction(i): void {
      this.editCurrentCustomAction = true
      this.editingExistingAction = i
      this.currentCustomAction = {
        actionText: this.validPlatforms[i].text,
        actionURL: this.validPlatforms[i].actionURL,
        actionImageType: this.validPlatforms[i].actionImageType,
        actionImageData: this.validPlatforms[i].actionImageData
      };   
    },
    addCustomAction(): void {
      // @ts-ignore
      this.editCurrentCustomAction = true
      this.currentCustomAction = {
        actionText: "",
        actionURL: "",
        actionImageType: "img",
        actionImageData: ""
      };      
      
    },
    refreshOptions(): void {
      //keep track of which actions added to view:
      const allActions = [
        "fbr",
        "gp",
        "tp",
        "g2",
        "ca",
        "ta",
        "ye",
        "fs",
      ];

      //go through current database value, if any, and see which are valid...
    if (this.field.length !== 0) {
      // @ts-ignore
      this.field.forEach((entry) => {
        //'fbs' (Facebook share) and 'tw' (tweet) are retired share actions — this step only
        //requests reviews now. Skipping them here drops them from the step on the next save
        //(the survey app still renders them on flows saved before the retirement).
        if (entry.platformCode === "fbs" || entry.platformCode === "tw") return;
        if (entry.platformCode === "fbr") {
          if (this.platformAvailability.fb) {
            // @ts-ignore
            const newEntry = {
              ...entry,
              active: true,
              text: this.$store.getters["dash/currentLanguagePack"][
                actionsMappedToLanguageSlugs[entry.platformCode]
              ],
            };
            // @ts-ignore
            this.validPlatforms.push(newEntry);
            allActions.splice(allActions.indexOf(entry.platformCode), 1);
          }
        } else {



          if (entry.platformCode !== 'custom') {
            if (this.platformAvailability[entry.platformCode]) {
            // @ts-ignore
            const newEntry = {
              ...entry,
              active: true,
              text: this.$store.getters["dash/currentLanguagePack"][
                actionsMappedToLanguageSlugs[entry.platformCode]
              ],
            };
            // @ts-ignore
            this.validPlatforms.push(newEntry);
            allActions.splice(allActions.indexOf(entry.platformCode), 1);
          }
          } else {                    
            this.validPlatforms.push({
              platformCode: 'custom',        
              text: entry.actionText,
              active: true,
              actionURL:  entry.actionURL,
              actionImageType:  entry.actionImageType,
              actionImageData: entry.actionImageData,
             })
          }
        


        }
      });
      }

      //go through REST of options, see which is valid (but not active)
      allActions.forEach((actn) => {
        if (actn === "fbr") {
          if (this.platformAvailability.fb) {
            // @ts-ignore
            this.validPlatforms.push({...{platformCode: actn,text: this.$store.getters["dash/currentLanguagePack"][actionsMappedToLanguageSlugs[actn]]},active: false});
          }
        } else {
          if (this.platformAvailability[actn]) {
            // @ts-ignore
            this.validPlatforms.push({...{platformCode: actn,text: this.$store.getters["dash/currentLanguagePack"][actionsMappedToLanguageSlugs[actn]]},active: false});
            }
        }
      });
    },
  },
  watch: {
    oneOrMoreSelected(v) {
      if (!v) {
        this.$emit('handleErrors', {
          fieldAddress: this.fieldAddress,
          hasErrors: true
        })
      } else {
        this.$emit('handleErrors', {
          fieldAddress: this.fieldAddress,
          hasErrors: false
        })
      }
    },
    validPlatforms: {
      handler(v): void {
        //update the field
        const toPush = [];
        //noconsoleconsole.log(v.length);

        v.forEach((actn) => {
          if (actn.active) {
            
            if (actn.platformCode === 'custom') {
              toPush.push({ 
                platformCode: actn.platformCode,
                actionText: actn.text, 
                actionURL: actn.actionURL,  
                actionImageType: actn.actionImageType,
                actionImageData: actn.actionImageData               
              });
            } else {
              toPush.push({ platformCode: actn.platformCode });
            }            
          }
        });

        if (toPush.length === 0) {
          this.field = [];
        } else {
          this.field = toPush;
        }
      },
      deep: true,
    },
  },
  computed: {
    oneOrMoreSelected(): boolean {

      let oneMore = false
      for (const pF of this.validPlatforms) {
        if (pF.active) {
          oneMore = true
          break
        }
      }

      return oneMore

    },
    field: {
      get: function (): any[] | false {
        // @ts-ignore
        return this.$store.getters["survey/stepField"](this.fieldAddress);
      },
      set: function (v: string): void {
        // @ts-ignore
        this.$store.commit("survey/CHANGE_FIELD", {
          // @ts-ignore
          fieldAddress: this.fieldAddress,
          val: v,
        });
      },
    },
    platformAvailability(): any {
      //determine if we have addresses/info available for each platform
      const toReturn = {};
      const pltforms = ["fb", "gp", "tp", "g2", "ca", "ta", "ye", "fs"];
      pltforms.forEach((pf) => {
        if (pf === "gp") {
          //available with a picked place OR a pasted review link (URL-only connect)
          toReturn["gp"] = this.$store.state.dash.viewData.business
            .externalPlatforms.gp.gpObject ||
          this.$store.state.dash.viewData.business.externalPlatforms.gp.useURL
            ? true
            : false;
        } else {
          toReturn[pf] = this.$store.state.dash.viewData.business
            .externalPlatforms[pf]
            ? typeof this.$store.state.dash.viewData.business.externalPlatforms[
                pf
              ].id !== "undefined"
              ? true
              : false
            : false;
        }
      });
      return toReturn;
    },
  },
  components: {
    vSelect,
    gp: Googlereview,
    fbr: Facebook,
    ta: Tripadvisor,
    ca: Capterra,
    fs: Foursquare,
    g2: G2,
    tp: Trustpilot,
    ye: Yelp,
    Draggable,
  },
});
